<template>
    <div>
      <ViewForm v-if="!$store.getters.cusId" :is-open="false" />
      <ViewFormUser v-else :is-open="false" />
    </div>
  </template>
  <script>
  import ViewForm from '@/views/center-business/purchase/order/csg-admin';
  import ViewFormUser from '@/views/center-business/purchase/order/csg';
  export default {
    name: 'BusinessPurchaseOrderCsgAdminclosedIndex',
    components: {
      ViewForm,
      ViewFormUser
    },
  };
  </script>
